// normalize CSS across browsers
import "./src/normalize.scss"
// custom CSS styles
import "./src/style.scss"
// send to piano analytics
import * as config from "./config"

const sendToPianoAnalytics = () => {
  const siteId = parseInt(config.piano_site_id)

  if (isNaN(siteId)) {
    return
  }

  /*pianoAnalytics.setConfigurations({
    site: siteId,
    collectDomain: "https://nssvsmp.pa-cd.com",
  })
  pianoAnalytics.setVisitorId(clientId)
  pianoAnalytics.sendEvent("page.display", {
    page_chapter1: "Portail Innovation",
    page: "index",
  })*/
}

sendToPianoAnalytics()
